module.exports = __webpack_public_path__ + "media/images/about-us-bg-957370af413d3540cfd60c4fe99044de.jpg";